<template>
  <section class="page-interaction boho-earn earn-page">
    <b-overlay :show="loading" no-center variant="transparent" rounded="sm">
      <template #overlay>
        <loading-spinner />
      </template>
      <nav class="as-tabs">
        <RouterLink
          :to="{name: mobile ? 'account-status-mobile' : 'account-status'}"
          class="as-tab"
        >
          {{ $t('Account Status') }}
        </RouterLink>
        <RouterLink
          :to="{name: mobile ? 'gains-mobile' : 'gains'}"
          class="as-tab active"
        >
          {{ $t('My Gains') }}
        </RouterLink>
        <RouterLink
          :to="{name: mobile ? 'cashouts-mobile' : 'cashouts'}"
          class="as-tab"
        >
          {{ $t('Cashouts Page Title') }}
        </RouterLink>
      </nav>
      <b-row>
        <b-col xl="6" lg="6" md="8" sm="12">
          <v-select
            v-model="period"
            :clearable="false"
            :disabled="loading"
            :label="$t('Period')"
            :options="periods"
            label="title"
            class="mb-2"
          />
          <div v-if="dataPeriod">
            <div class="earn-hero">
            <div class="d-flex align-items-center">
              {{ $t('Beans') }} :
              <b-img :src="iconBean" width="22" class="mr-05 ml-1"/>
              <span class="total-gains-text">
                {{ numberFormatter(dataPeriod.earnedCredits) }}
              </span>
            </div>
            <div v-if="quotaLevel" class="fs-14 d-flex justify-content-st align-items-center">
              <span style="flex: 0 0 auto">
                {{ $t('Quota level') }} :
              </span>
              <b-progress
                :max="5"
                show-progress
                animated
                striped
                height="1rem"
                style="flex: 1; margin-left: 8px;"
                variant="warning"
              >
                <b-progress-bar :value="quotaLevel.level" :label="`${quotaLevel.level}`" />
              </b-progress>
            </div>
            <div
              v-if="quotaLevel && period && Array.isArray(periods) && period.title !== periods[0].title"
              class="fs-14 d-flex align-items-center"
            >
              {{ $t('Earned bonus') }} :
              {{ numberFormatter(parseInt(dataPeriod.earnedCreditsBonusCredit)) }}
            </div>
            <div @click="quotaModal = !quotaModal" class="fs-12 text-underline cursor-pointer text-right">
              {{ $t('View quotas') }}
            </div>

            <b-modal
              v-model="quotaModal"
              :title="$t('Quotas')"
              centered
              hide-footer
            >
              <p>
                {{ $t('Based on weekly activity beans') }}
              </p>
              <b-table
                striped
                hover
                :items="quotaLevels.filter(l => l.beans > 0)"
                :fields="quotaLevelTableFields" />
              <b-list-group v-if="false">
                <b-list-group-item v-for="level in quotaLevels.filter(l => l.level > 0)" :key="level.level">
                  <span style="color: #ff1000;">
                    {{ level.level }}
                  </span>:
                  {{ level.text }}
                </b-list-group-item>
              </b-list-group>
            </b-modal>
            </div>
            <div class="earn-list">
            <b-row class="mb-2">
              <b-col md="12">
                <div class="d-flex justify-content-between w-100 gains-text">
                  <div class="d-flex align-items-center">
                    <b-img :src="iconBean" width="14" class="mr-05"/>
                    <span>
                        {{ $t('Activity beans') }}
                      </span>
                  </div>
                  <div class="d-flex align-items-center">
                    {{ numberFormatter(activityBeans) }}
                  </div>
                </div>
              </b-col>
            </b-row>
            <!--
            <b-row class="mb-2">
              <b-col md="12">
                <div class="d-flex justify-content-between w-100 gains-text">
                  <div class="d-flex align-items-center">
                    <b-img :src="iconBean" width="14" class="mr-05"/>
                    <span>
                        {{ $t('Live Streaming') }}
                      </span>
                  </div>
                  <div class="d-flex align-items-center">
                    {{ numberFormatter(dataPeriod.earnedCreditsStreamGift) }}
                  </div>
                </div>
              </b-col>
            </b-row>
            -->
            <b-row class="mb-2">
              <b-col md="12">
                <div class="d-flex justify-content-between w-100 gains-text">
                  <div class="d-flex align-items-center">
                    <b-img :src="iconBean" width="14" class="mr-05"/>
                    <span>
                        {{ $t('Video Call') }}
                      </span>
                  </div>
                  <div class="d-flex align-items-center">
                    {{ numberFormatter(dataPeriod.earnedCreditsVideoCall) }}
                  </div>
                </div>
              </b-col>
            </b-row>
            <!--
            <b-row class="mb-2">
              <b-col md="12">
                <div class="d-flex justify-content-between w-100 gains-text">
                  <div class="d-flex align-items-center">
                    <b-img :src="iconBean" width="14" class="mr-05"/>
                    <span>
                        {{ $t('Random Call') }}
                      </span>
                  </div>
                  <div class="d-flex align-items-center">
                    {{ numberFormatter(dataPeriod.earnedCreditsRandomVideoCall) }}
                  </div>
                </div>
              </b-col>
            </b-row>
            -->
            <b-row class="mb-2">
              <b-col md="12">
                <div class="d-flex justify-content-between w-100 gains-text">
                  <div class="d-flex align-items-center">
                    <b-img :src="iconBean" width="14" class="mr-05"/>
                    <span>
                        {{ $t('Voice Call') }}
                      </span>
                  </div>
                  <div class="d-flex align-items-center">
                    {{ numberFormatter(dataPeriod.earnedCreditsCall) }}
                  </div>
                </div>
              </b-col>
            </b-row>
            <!-- Hediye satışı kaldırıldı — hediye geliri satırı gizlendi (toplam hesabında kalmaya devam ediyor)
<b-row class="mb-2">
              <b-col md="12">
                <div class="d-flex justify-content-between w-100 gains-text">
                  <div class="d-flex align-items-center">
                    <b-img :src="iconBean" width="14" class="mr-05"/>
                    <span>
                        {{ $t('Gifts') }}
                      </span>
                  </div>
                  <div class="d-flex align-items-center">
                    {{ numberFormatter(dataPeriod.earnedCreditsGift) }}
                  </div>
                </div>
              </b-col>
            </b-row>
            -->
            <!--
            <b-row class="mb-2">
              <b-col md="12">
                <div class="d-flex justify-content-between w-100 gains-text">
                  <div class="d-flex align-items-center">
                    <b-img :src="iconBean" width="14" class="mr-05"/>
                    <span>
                        {{ $t('Chat') }}
                      </span>
                  </div>
                  <div class="d-flex align-items-center">
                    {{ numberFormatter(dataPeriod.earnedCreditsChat) }}
                  </div>
                </div>
              </b-col>
            </b-row>
            -->
            <b-row class="mb-2">
              <b-col md="12">
                <div class="d-flex justify-content-between w-100 gains-text">
                  <div class="d-flex align-items-center">
                    <b-img :src="iconBean" width="14" class="mr-05"/>
                    <span>
                        {{ $t('Photo requests') }}
                      </span>
                  </div>
                  <div class="d-flex align-items-center">
                    {{ numberFormatter(dataPeriod.earnedCreditsMediaRequestPhoto || 0) }}
                  </div>
                </div>
                <div v-if="dataPeriod.mediaRequestSummary" class="gains-sub-text mt-05">
                  <div class="d-flex justify-content-between">
                    <span>{{ $t('Requests received') }}</span>
                    <span>{{ numberFormatter(mediaRequestPhotoSummary.requests) }}</span>
                  </div>
                  <div class="d-flex justify-content-between">
                    <span>{{ $t('Requests answered') }}</span>
                    <span>{{ numberFormatter(mediaRequestPhotoSummary.fulfilledRequests) }}</span>
                  </div>
                  <div class="d-flex justify-content-between">
                    <span>{{ $t('Requests unlocked') }}</span>
                    <span>{{ numberFormatter(mediaRequestPhotoSummary.unlockedRequests) }}</span>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col md="12">
                <div class="d-flex justify-content-between w-100 gains-text">
                  <div class="d-flex align-items-center">
                    <b-img :src="iconBean" width="14" class="mr-05"/>
                    <span>
                        {{ $t('Video requests') }}
                      </span>
                  </div>
	                  <div class="d-flex align-items-center">
	                    {{ numberFormatter(dataPeriod.earnedCreditsMediaRequestVideo || 0) }}
	                  </div>
	                </div>
                <div v-if="dataPeriod.mediaRequestSummary" class="gains-sub-text mt-05">
                  <div class="d-flex justify-content-between">
                    <span>{{ $t('Requests received') }}</span>
                    <span>{{ numberFormatter(mediaRequestVideoSummary.requests) }}</span>
                  </div>
                  <div class="d-flex justify-content-between">
                    <span>{{ $t('Requests answered') }}</span>
                    <span>{{ numberFormatter(mediaRequestVideoSummary.fulfilledRequests) }}</span>
                  </div>
                  <div class="d-flex justify-content-between">
                    <span>{{ $t('Requests unlocked') }}</span>
                    <span>{{ numberFormatter(mediaRequestVideoSummary.unlockedRequests) }}</span>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col md="12">
                <div class="d-flex justify-content-between w-100 gains-text">
                  <div class="d-flex align-items-center">
                    <b-img :src="iconBean" width="14" class="mr-05"/>
                    <span>
                        {{ $t('Games') }}
                      </span>
                  </div>
                  <div class="d-flex align-items-center">
                    {{ numberFormatter(dataPeriod.earnedCreditsGame || 0) }}
                  </div>
                </div>
              </b-col>
            </b-row>
            <hr>
            <b-row class="mb-2">
              <b-col md="12">
                <div class="d-flex justify-content-between w-100 gains-text">
                  <div class="d-flex align-items-center">
                    <b-img :src="iconBean" width="14" class="mr-05"/>
                    <span>
                        {{ $t('Bonus') }}
                      </span>
                  </div>
                  <div class="d-flex align-items-center">
                    {{ numberFormatter(dataPeriod.earnedCreditsBonusCredit) }}
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col md="12">
                <div class="d-flex justify-content-between w-100 gains-text">
                  <div class="d-flex align-items-center">
                    <b-img :src="iconBean" width="14" class="mr-05"/>
                    <span>
                        {{ $t('Daily tasks & rewards') }}
                      </span>
                  </div>
                  <div class="d-flex align-items-center">
                    {{ numberFormatter(dataPeriod.earnedCreditsIncentive) }}
                  </div>
                </div>
              </b-col>
            </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-overlay>
  </section>
</template>

<script>
// freeCallUser
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BAlert, BAvatar, BBadge, BButton, BCard, BCarousel, BCarouselSlide, BCol, BDropdown, BDropdownItem, BForm, BFormGroup,
  BFormInput, BFormTextarea, BImg, BLink, BListGroup, BListGroupItem, BMedia, BNav, BNavItem, BOverlay, BPagination,
  BProgress, BProgressBar, BRow, BSpinner, BTable, BTabs, BTab,
} from 'bootstrap-vue'
import { Carousel3d, Slide } from 'vue-carousel-3d'
import useJwt from '@/auth/jwt/useJwt'
import {throwDefaultError, numberFormatter} from '@/helpers/helpers'
import StatusIndicator from '@/components/StatusIndicator'
import DiscoverNoUser from '@/components/DiscoverNoUser'
import CallCard from '@/components/CallCard'
import vSelect from 'vue-select'
import moment from 'moment'
import _ from 'lodash'
import 'vue-select/dist/vue-select.css'

// import { getUser } from '@/auth/utils'

export default {
  name: 'GainsComponent',
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BAlert,
    BAvatar,
    BBadge,
    BButton,
    BCard,
    BCarousel,
    BCarouselSlide,
    BCol,
    BDropdown,
    BDropdownItem,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BImg,
    BLink,
    BListGroup,
    BListGroupItem,
    BMedia,
    BNav,
    BNavItem,
    BOverlay,
    BPagination,
    BProgress,
    BProgressBar,
    BRow,
    BSpinner,
    BTable,
    BTabs,
    BTab,

    CallCard,
    DiscoverNoUser,
    StatusIndicator,

    Carousel3d,
    Slide,

    vSelect,

    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      activeTabIndex: 0,
      data: null,
      dataPeriod: null,
      gainRequest: {
        accountHolder: '',
        bankName: '',
        iban: '',
      },
      iconBean: require('@/assets/images/icons/bean.png'),
      iconDiamond: require('@/assets/images/icons/diamonds-1.svg'),
      iconPhone: require('@/assets/images/icons/phone-green.svg'),
      limit: 300,
      loading: false,
      period: null,
      quotaLevelFields: [
        { key: 'level', label: '' },
        { key: 'text', label: '' },
      ],
      quotaLevelTableFields: [
        { key: 'beansText', label: this.$t('Activity beans') },
        { key: 'rateText', label: this.$t('Bonus') },
      ],
      quotaModal: false,
      streamStatistics: null,
    }
  },
  created() {},
  watch: {
    period(value) {
      console.log('watch period', value)
      this.getGainsPeriod(value.startDate, value.endDate)
    }
  },
  computed: {
    mediaRequestSummary() {
      return (this.dataPeriod && this.dataPeriod.mediaRequestSummary) || {}
    },
    mediaRequestPhotoSummary() {
      const summary = this.mediaRequestSummary
      const hasBreakdown = summary.photoRequests !== undefined
      return {
        requests: hasBreakdown ? (summary.photoRequests || 0) : (summary.totalRequests || 0),
        fulfilledRequests: hasBreakdown ? (summary.photoFulfilledRequests || 0) : (summary.fulfilledRequests || 0),
        unlockedRequests: hasBreakdown ? (summary.photoUnlockedRequests || 0) : (summary.unlockedRequests || 0),
      }
    },
    mediaRequestVideoSummary() {
      const summary = this.mediaRequestSummary
      return {
        requests: summary.videoRequests || 0,
        fulfilledRequests: summary.videoFulfilledRequests || 0,
        unlockedRequests: summary.videoUnlockedRequests || 0,
      }
    },
    activityBeans() {
      let total = 0
      if (this.dataPeriod) {
        total = parseInt(this.dataPeriod['earnedCreditsChat'])
            + parseInt(this.dataPeriod['earnedCreditsGift'])
            + parseInt(this.dataPeriod['earnedCreditsCall'])
            + parseInt(this.dataPeriod['earnedCreditsRandomVideoCall'])
            + parseInt(this.dataPeriod['earnedCreditsVideoCall'])
            + parseInt(this.dataPeriod['earnedCreditsStreamGift'])
            + parseInt(this.dataPeriod['earnedCreditsMultimedia'])
      }
      return total
    },
    quotaLevel() {
      let quotaLevel = null

      this.quotaLevels.map(level => {
        if (this.dataPeriod && this.activityBeans >= level.beans) {
          quotaLevel = level
        }
      })

      return quotaLevel
    },
    quotaLevels() {
      return [
        {
          beans: 0,
          beansText: '0',
          level: 0,
          rate: 0,
          rateText: '%0',
          text: '',
        },
        {
          beans: 25000,
          beansText: '25.000',
          level: 1,
          rate: 0.1,
          rateText: '%10',
          text: this.$t('quota_level_text', { beans: '25.000+', rate: '%10' }),
        },
        {
          beans: 50000,
          beansText: '50.000',
          level: 2,
          rate: 0.15,
          rateText: '%15',
          text: this.$t('quota_level_text', { beans: '50.000+', rate: '%15' }),
        },
        {
          beans: 75000,
          beansText: '75.000',
          level: 3,
          rate: 0.20,
          rateText: '%20',
          text: this.$t('quota_level_text', { beans: '75.000+', rate: '%20' }),
        },
        {
          beans: 100000,
          beansText: '100.000',
          level: 4,
          rate: 0.25,
          rateText: '%25',
          text: this.$t('quota_level_text', { beans: '100.000+', rate: '%25' }),
        },
        {
          beans: 200000,
          beansText: '200.000',
          level: 5,
          rate: 0.30,
          rateText: '%30',
          text: this.$t('quota_level_text', { beans: '200.000+', rate: '%30' }),
        },
      ]
    },
    periods() {
      // Haftanın ilk günün Pazartesi yapıyoruz
      moment.updateLocale('en', {
        week: {
          dow: 1,
        },
      })

      const periods = Array.from(Array(8).keys()).map(i => {
        let text = i === 0 ? this.$t('This week') : (i === 1 ? this.$t('Previous week') : '')
        const dates = {
          startDate: moment().subtract(i, 'week').startOf('week').format('YYYY-MM-DD'),
          endDate: moment().subtract(i, 'week').endOf('week').format('YYYY-MM-DD'),
        }

        if (i > 1)
          text = `${moment(dates.startDate).format('DD-MM-YYYY')} - ${moment(dates.endDate).format('DD-MM-YYYY')}`

        return {
          title: text,
          ...dates,
        }
      })

      console.log('periods', periods)

      this.period = periods[0]

      return periods
    }
  },
  methods: {
    numberFormatter,
    getGainsPeriod(startDate = null, endDate = null) {
      this.loading = true

      const data = { startDate, endDate }

      useJwt.accountEarnedCredits(data)
          .then(response => {
            this.dataPeriod = response.data.body
          })
          .catch(error => {
            throwDefaultError(this.$toast, error)
          })
          .finally(() => { this.loading = false })
    },
    getDate(date) {
      return moment(date).format('DD.MM.YYYY HH:mm:ss')
    },
    timeLeft(time) {
      if (time <= 0) return '0'

      let result = ''
      let totalSeconds = time;

      const days = Math.floor(totalSeconds / (60 * 60 * 24))
      totalSeconds -= days * (60 * 60 * 24)

      const hours = Math.floor(totalSeconds / (60 * 60))
      totalSeconds -= hours * (60 * 60)

      const minutes = Math.floor(totalSeconds / (60))
      totalSeconds -= minutes * 60

      const seconds = Math.floor(totalSeconds % 60)

      // if (days > 0) {
      //   result += days + ` ${this.$t('days')}, `
      // }

      if (hours > 0) {
        result += hours + ` ${this.$t('hours')}, `
      }

      if (minutes > 0) {
        result += minutes + ` ${this.$t('minutes')}, `
      }

      if (seconds > 0) {
        result += seconds + ` ${this.$t('seconds')}, `
      }

      return _.trimEnd(result, ', ')
    }
  }
}
</script>

<style lang="scss" scoped>
.total-gains-text {
  font-family: 'Lexend', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 28px;
}
.gains-text {
  font-family: 'Lexend', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
}
.gains-sub-text {
  padding-left: 22px;
  font-family: 'Lexend', sans-serif;
  font-size: 12px;
  line-height: 18px;
}
.nav-link {
  a {
    font-size: 13px !important;
  }
  &.active {
    a {
      color: #ffffff !important;
    }
  }
}
.nav-pills .nav-link {
  padding: 0.786rem 0.35rem !important;
}
</style>

<style lang="scss">
@import '~@/assets/scss/boho-earnings.scss';
</style>

<route lang="yaml">
meta:
  navActiveLink: account-status
</route>
